import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  HomeIcon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { Tabs } from "../../components/Widget/Tab";
import { find, store } from "../../services/service";
import { useStoreSurvey } from "../../store/SurveyStore";
import {
  EQUIPE_COORDO,
  EXPORT_EXCEL_RDV_ATTRIBUE_EQUIPE,
  RENDEZ_VOUS_EN_ATTENTE_ATTRIBUER_PAR_EQUIPE,
} from "../../Utils/constant";
import { checkTagValidity } from "../../Utils/Utils";
import PrestataireAttributionCoordo from "./PrestataireAttributionCoordo";

const HomeAttributionCoordo = () => {
  const [active, setActive] = useState({
    value: "en-attente",
    index: 0,
  });
  const [exportLoading, setExportLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [assignModalItem, setAssignModalItem] = useState(null);
  const [selectedPrestataire, setSelectedPrestataire] = useState("");
  const [isAssigning, setIsAssigning] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const dataListe = useStoreSurvey();
  const [equipes, setEquipe] = useState([]);
  const [loader, setLoader] = useState(true);

  const getEquipeListe = async (prestataire) => {
    setLoader(true);
    await find(`${EQUIPE_COORDO}?prestataireId=${prestataire}`).then((res) => {
      setEquipe(res.data?.donnee);
      setLoader(false);
    });
  };
  const tabs = [
    {
      value: "En attente d'attribution",
      index: 0,
      tag: "LISTE_RDV_EN_ATTENTE_ATTRIBUTION_EQUIPE",
    },
    {
      value: "Attributions effectuées",
      index: 1,
      tag: "LISTE_RDV_ATTRIBUER_EQUIPES",
    },
  ];
  const filteredTabsData = tabs
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[0]);
    }
  }, []);
  // Fonction de recherche avec debounce
  const handleSearch = (value) => {
    setSearchTerm(value);
    setIsSearching(true);
    dataListe
      .getData(
        `${RENDEZ_VOUS_EN_ATTENTE_ATTRIBUER_PAR_EQUIPE}?page=0&param=${value}&size=8`,
      )
      .finally(() => setIsSearching(false));
  };

  const moreEnAttente = (page) => {
    dataListe.getData(
      `${RENDEZ_VOUS_EN_ATTENTE_ATTRIBUER_PAR_EQUIPE}?page=${
        page - 1
      }&param=${searchTerm}&size=8`,
    );
  };

  const handleAssignEquipe = async () => {
    if (!assignModalItem || !selectedPrestataire) return;

    setIsAssigning(true);
    setMsg("");
    try {
      const res = await store(
        `/commerciale/rdv-corbeille/v3/${assignModalItem.abonnement?.id}/attribuer-equipe/${selectedPrestataire}`,
        "application/json",
        {},
      );

      if (res.status === 200) {
        await dataListe.getData(
          `${RENDEZ_VOUS_EN_ATTENTE_ATTRIBUER_PAR_EQUIPE}?page=0&param=${searchTerm}&size=8`,
        );
        document.getElementById("assign-modal").close();
        setAssignModalItem(null);
        setSelectedPrestataire("");
        toast.success("Prestataire affecté avec succès");
      }
    } catch (err) {
      const errorMsg =
        err?.response?.data?.donnee || "Erreur lors de l'attribution";
      setMsg(errorMsg);
      toast.error(errorMsg);
    } finally {
      setIsAssigning(false);
    }
  };

  useEffect(() => {
    dataListe.getData(
      `${RENDEZ_VOUS_EN_ATTENTE_ATTRIBUER_PAR_EQUIPE}?page=0&param=&size=8`,
    );
  }, []);

  return (
    <div className="">
      {/* Header */}
      <div className="lg:flex items-center justify-between mb-4">
        <div>
          <h3 className="font-mtn text-3xl font-bold">
            Gestion des attributions par equipe
          </h3>
          <p className="text-sm text-gray-500">
            Attribution intelligente des clients aux prestataires
          </p>
          <div className="my-2">
            <button
              className="btn btn-sm bg-main border-main flex items-center min-w-[220px] justify-center"
              disabled={exportLoading}
              onClick={async () => {
                setExportLoading(true);
                try {
                  const res = await store(
                    EXPORT_EXCEL_RDV_ATTRIBUE_EQUIPE,
                    null,
                    null,
                    { responseType: "blob" },
                  );
                  if (res?.data) {
                    const url = window.URL.createObjectURL(res.data);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                      "download",
                      "rdv_attente_attribution.xlsx",
                    );
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                  }
                } catch (err) {
                  toast.error("Erreur lors de l'export");
                } finally {
                  setExportLoading(false);
                }
              }}
            >
              {exportLoading ? (
                <span className="flex items-center gap-2">
                  <Loader2 className="animate-spin h-4 w-4" />
                  Export en cours...
                </span>
              ) : (
                "Exporter RDV en attente d'attribution"
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <Tabs active={active} setActive={setActive} tabsData={filteredTabsData} />

      {/* Modal Affecter Prestataire */}
      <dialog id="assign-modal" className="modal">
        <div className="modal-box w-96">
          <h3 className="font-bold text-lg">Affecter une equipe</h3>
          <p className="text-sm text-gray-500 mb-3">
            Sélectionnez l'equipe à affecter pour ce rendez-vous.
          </p>
          {msg && <p className="text-red-500 text-sm mb-2">{msg}</p>}
          {equipes?.length === 0 && !loader ? (
            <p className="text-xs text-red-500">
              Aucune equipe disponible pour ce prestataire.
            </p>
          ) : (
            <div className=" mb-3">
              <select
                value={selectedPrestataire}
                onChange={(e) => setSelectedPrestataire(e.target.value)}
                className=" select select-bordered w-full"
                disabled={isAssigning || loader}
              >
                <option value="">
                  {loader
                    ? "Chargement des equipes..."
                    : "-- Choisir une equipe --"}
                </option>
                {equipes?.map((p) => (
                  <option key={p.id} value={p.id}>
                    {p.designation}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="modal-action">
            <button
              onClick={handleAssignEquipe}
              disabled={isAssigning || !selectedPrestataire}
              className={`btn btn-sm ${
                isAssigning || !selectedPrestataire
                  ? "btn-disabled opacity-50"
                  : "bg-main text-black border-main"
              }`}
            >
              {isAssigning ? (
                <>
                  <Loader2 className="w-4 h-4 animate-spin" />
                  Affectation...
                </>
              ) : (
                "Affecter"
              )}
            </button>
            <button
              onClick={() => {
                document.getElementById("assign-modal").close();
                setAssignModalItem(null);
                setMsg("");
              }}
              disabled={isAssigning}
              className="btn btn-sm"
            >
              Annuler
            </button>
          </div>
        </div>
      </dialog>

      {/* Contenu principal */}
      {active.index === 0 ? (
        <div className="bg-white rounded-md px-2 py-4 mt-3">
          {/* Filtres */}
          <div className="flex items-center gap-3 mb-4">
            <div className="relative flex-1 max-w-sm">
              <input
                type="text"
                value={searchTerm}
                disabled={dataListe.loading}
                onChange={(e) => handleSearch(e.target.value)}
                placeholder="Rechercher un élément..."
                className="text-xs input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
              />
              {isSearching && (
                <Loader2 className="w-4 h-4 animate-spin absolute right-3 top-3 text-gray-400" />
              )}
            </div>
          </div>

          {/* Grille des rendez-vous */}
          {dataListe?.loading ? (
            <div className="flex flex-col justify-center items-center py-20 space-y-3">
              <Loader2 className="w-8 h-8 animate-spin text-main" />
              <span className="ml-3 text-gray-600 text-sm">
                Chargement des données...
              </span>
            </div>
          ) : dataListe?.data?.data?.length === 0 ? (
            <div className="text-center py-20">
              <p className="text-sm text-gray-500">Aucune donnée disponible</p>
            </div>
          ) : (
            <>
              <div className="grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
                {dataListe?.data?.data?.map((item) => (
                  <div
                    key={item.id}
                    className={`${
                      !item?.inTime
                        ? "border-red-300 border-2 border-dashed"
                        : "border-slate-200 border"
                    } relative bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow`}
                  >
                    <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                      <p className="text-[12px] font-semibold">
                        N° {item?.abonnement?.eligibilite?.numeroTicket}
                      </p>
                    </div>
                    <div className="px-3 py-2">
                      <div className="items-center gap-2 space-y-3">
                        <Periode item={item} />
                        <Pbo
                          pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                          port={item?.brin}
                        />
                        <div className="flex gap-1 my-3">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement?.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement.client?.numero}</span>
                              {item?.abonnement.client?.secondNumero && (
                                <>
                                  {" | "}
                                  <span>
                                    {item?.abonnement.client?.secondNumero}
                                  </span>
                                </>
                              )}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-2">
                          <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <CalendarIcon />
                              {item?.dateRdv}
                            </p>
                          </div>
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>

                        <div className="gap-1">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p>
                          </div>
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Equipe en charge : {item?.equipe?.designation}
                        </h1>
                        {item.commentaire && (
                          <div className="dropdown flex items-center">
                            <p className="text-xs">
                              Commentaire: {item?.commentaire}
                            </p>
                          </div>
                        )}
                        <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <HomeIcon />
                            {item?.abonnement?.batiment?.designation}
                          </p>
                          <p className="text-xs flex gap-1 font-medium">
                            <ArchiveIcon />
                            {item?.abonnement?.equipement?.designation}
                          </p>
                        </div>
                      </div>
                      <h1 className="my-2 text-[13px] font-medium flex items-center">
                        <SewingPinFilledIcon />
                        {item?.abonnement?.commune +
                          ", " +
                          item?.abonnement?.quartier}
                      </h1>
                      <div className="flex items-center gap-1">
                        <h5 className="text-xs font-medium">Etape:</h5>
                        <p className="bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                          {item?.abonnement?.status
                            ?.toLowerCase()
                            .replace(/_/g, " ")}
                        </p>
                      </div>

                      <div className="flex items-center gap-1">
                        {!item?.retourner && (
                          <button
                            onClick={() => {
                              getEquipeListe(item?.prestataire?.id);
                              setAssignModalItem(item);
                              setSelectedPrestataire("");
                              setMsg("");
                              document
                                .getElementById("assign-modal")
                                .showModal();
                            }}
                            className="btn btn-sm bg-main border-main my-3 font-mtn text-xs font-regular hover:bg-opacity-90 transition-colors"
                          >
                            Attribuer
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="my-3 flex justify-end">
                <Pagination
                  onChange={(event, newValue) => moreEnAttente(newValue)}
                  count={dataListe?.data?.totalPages}
                  variant="outlined"
                  color="primary"
                  shape="rounded"
                />
              </div>
            </>
          )}
        </div>
      ) : active?.index === 1 ? (
        <PrestataireAttributionCoordo />
      ) : null}
    </div>
  );
};

export default HomeAttributionCoordo;
